import React, { useState } from 'react';
import {
    Button,
    IconButton,
    HeadingText50,
    HeadingText30,
    BodyTextMedium,
} from '@modernhealth/vital-components';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { ImageBottomLeft, ImageBottomRight } from './PageIllustrations';

interface Props {
    title: string;
    subtitle: string;
    description: string;
    buttonText: string;
    buttonArrow?: boolean;
    onSubmit: () => Promise<void> | void;
    onClose: () => void;
}

export const CreatePathwayLayout = ({
    title,
    subtitle,
    description,
    buttonText,
    buttonArrow,
    onSubmit,
    onClose,
}: Props) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);

    return (
        <>
            <IconButton
                title={t('common.close')}
                onClick={onClose}
                icon="x"
                size="medium"
                variant="secondary"
                css={{
                    position: 'absolute',
                    top: 20,
                    right: 20,
                }}
            />
            <ImageBottomLeft />
            <ImageBottomRight />
            <Container>
                <HeadingText30 marginBottom={8} centered>
                    {subtitle}
                </HeadingText30>
                <HeadingText50 marginBottom={12} centered>
                    {title}
                </HeadingText50>
                <BodyTextMedium marginBottom={44} centered>
                    {description}
                </BodyTextMedium>
                <Button
                    icon={buttonArrow ? 'arrow-right' : undefined}
                    iconAlign="end"
                    busy={loading}
                    size="large"
                    onClick={async () => {
                        setLoading(true);

                        try {
                            await onSubmit();
                        } catch {
                            setLoading(false);
                        }
                    }}
                >
                    {buttonText}
                </Button>
            </Container>
        </>
    );
};

const Container = styled.div({
    padding: 30,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: 700,
    margin: '0 auto',
});
